import { Flex } from '@mantine/core';
import type { FC, MouseEventHandler } from 'react';

import { Button } from '../../ui/Button/Button.tsx';

interface ButtonTypeSubmitProps {
  type: 'submit';
  onClick?: never;
}

interface ButtonTypeButtonProps {
  type: 'button';
  onClick: MouseEventHandler<HTMLButtonElement>;
}

interface BaseButtonProps {
  text: string;
  isPending?: boolean;
}

interface ButtonRowProps {
  primaryButton: BaseButtonProps & (ButtonTypeButtonProps | ButtonTypeSubmitProps);
  secondaryButton?: Omit<BaseButtonProps & ButtonTypeButtonProps, 'type'>;
}

export const ButtonRow: FC<ButtonRowProps> = ({ secondaryButton, primaryButton }) => {
  return (
    <Flex justify="space-between">
      {secondaryButton ? (
        <Button
          intent="secondary"
          loading={secondaryButton?.isPending}
          text={secondaryButton.text}
          type="button"
          onClick={secondaryButton.onClick}
        />
      ) : (
        <div />
      )}

      <Button {...primaryButton} loading={primaryButton?.isPending} />
    </Flex>
  );
};
